<template>
  <div class="Box">

    <div class="container">
      <div style="padding: 10px;z-index: 99999;float: left" class="adminLogin">
        <a href="/login" style="font-size: larger" >
          管理员登录
        </a>
      </div>
      <div class="box">
        <div class="box-left">
          <div class="group">
            <a href="https://ndyy.ncu.edu.cn/api/cas/login" style="text-decoration: none;">
              <div class="choice">
                <div class="choice-info">
                  <img src="../assets/img/icon02.svg" alt="">
                  <p>教职工</p>
                </div>
              </div>
            </a>
            <a href="https://ndyy.ncu.edu.cn/api/cas/login" style="text-decoration: none;">
              <div class="choice">
                <div class="choice-info">
                  <img src="../assets/img/icon02.svg" alt="">
                  <p>学生</p>
                </div>
              </div>
            </a>
            <!--          <a href="/login" style="text-decoration: none;">-->
            <!--            <div class="choice">-->
            <!--              <div class="choice-info">-->
            <!--                <img src="../assets/img/icon01.svg" alt="">-->
            <!--                <p>管理员</p>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--          </a>-->
            <router-link :to="{name:'SocialUser',params:{'index':1}}"  style="text-decoration: none;">
              <div class="choice">
                <div class="choice-info">
                  <img src="../assets/img/icon02.svg" alt="">
                  <p>校友登录</p>
                </div>
              </div>
            </router-link>
            <router-link :to="{name:'SocialUser',params:{'index':2}}" style="text-decoration: none;">
              <div class="choice">
                <div class="choice-info">
                  <img src="../assets/img/icon02.svg" alt="">
                  <p>附属单位登录</p>
                </div>
              </div>
            </router-link>
            <router-link :to="{name:'SocialUser',params:{'index':3}}" style="text-decoration: none;">
              <div class="choice">
                <div class="choice-info">
                  <img src="../assets/img/icon01.svg" alt="">
                  <p>社会人员</p>
                </div>
              </div>
            </router-link>

          </div>
          <p style="font-size: 18px;text-align: left;padding-left:100px;">
            <span style="text-align: left;">注意：1.请使用Chrome浏览器或Edge浏览器</span><br/>
            <span style="text-align: left;">&nbsp;&nbsp;&nbsp;2.请保证屏幕分辨率在1280*800以上</span><br/>
            <span style="text-align: left;">&nbsp;&nbsp;&nbsp;3.请不要屏蔽弹出窗口</span><br/>
            <span style="text-align: left;">问题咨询：南昌大学体育场馆中心（羽毛球馆：83969206，游泳馆：83969696）</span>
          </p>
        </div>
        <div class="box-right">
          <p>欢迎<span>登录</span></p>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

// import "../CSS/newLogin.css"

export default {
  name: "SelectLogin",

  methods:{
    wait(){
      this.$alert('很抱歉，该功能尚未开放，敬请期待', '错误', {
        confirmButtonText: '确定',
        callback: action => {
          this.$message({
            type: 'info',
            message: `很抱歉给您带来的不便`
          });
        }
      });
    },
  }
}
</script>

<style src="../CSS/newLogin.css" scoped>
</style>
<style scoped>
.adminLogin{
  position: absolute;
  top: 0;
  left: 0;
}
</style>